import { Uuid } from "@formant/core/model/Uuid";

import { hashObservable } from "../../utils/hashObservable";

export class ViewDeviceState {
    @hashObservable()
    viewId: Uuid | undefined;
}
